export enum AttachmentObjectType {
  Attachments = 'attachments',
  GeneralAttachments = 'generalAttachments',
  RequirementAttachments = 'requirementAttachments',
  StoryAttachments = 'storyAttachments'
}
